import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import PrivacyPolicy from '../views/CGU/PrivacyPolicy'

import Login from '../views/auth/Login'

import Profile from '../views/user/Profile'

import FarmerIndex from '../views/farmer/FarmerIndex'
import FarmerShow from '../views/farmer/FarmerShow'
import FarmerCreateEdit from '../views/farmer/FarmerCreateEdit'

import AuditCreateEdit from '../views/audit/AuditCreateEdit'
import AuditShow from '../views/audit/AuditShow'

import TechnicianIndex from '../views/technician/TechnicianIndex'
import TechnicianShow from '../views/technician/TechnicianShow'
import TechnicianCreateEdit from '../views/technician/TechnicianCreateEdit'

import StructureIndex from '../views/structure/StructureIndex'
import StructureCreateEdit from '../views/structure/StructureCreateEdit'
import StructureShow from '../views/structure/StructureShow'

import AdminIndex from '../views/admin/AdminIndex'
import AdminCreateEdit from '../views/admin/AdminCreateEdit'
import AdminShow from '../views/admin/AdminShow'

import PracticeIndex from '../views/practice/PracticeIndex'
import PracticeEdit from "../views/practice/PracticeEdit";

import ResourceIndex from '../views/resource/ResourceIndex'
import ResourceCreateEdit from '../views/resource/ResourceCreateEdit'
import ResourceShow from '../views/resource/ResourceShow'

import FeedbackIndex from '../views/feedback/FeedbackIndex'
import FeedbackShow from '../views/feedback/FeedbackShow'

import VideoIndex from '../views/videoRobustagno/VideoIndex'
import VideoCreateEdit from '../views/videoRobustagno/VideoCreateEdit'
import VideoShow from '../views/videoRobustagno/VideoShow'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/farmers'
  },

  {
    path: '/privacyPolicy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: {
      guest: true
    }
  },

  {
    path: '/login/:component?/:token?/:userId?',
    name: 'Login',
    component: Login,
    meta: {
      guest: true
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_TECHNICIAN', 'ROLE_STRUCTURE']
    }
  },

  {
    path: '/farmers',
    name: 'FarmerIndex',
    component: FarmerIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_TECHNICIAN', 'ROLE_STRUCTURE']
    }
  },

  {
    path: '/farmer/show/:farmerId',
    name: 'FarmerShow',
    component: FarmerShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_TECHNICIAN', 'ROLE_STRUCTURE']
    }
  },

  {
    path: '/farmer/edit/:farmerId',
    name: 'FarmerEdit',
    component: FarmerCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_TECHNICIAN', 'ROLE_STRUCTURE']
    }
  },
  {
    path: '/farmer/create',
    name: 'FarmerCreate',
    component: FarmerCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_TECHNICIAN', 'ROLE_STRUCTURE']
    }
  },

  {
    path: '/audit/create/:farmerId',
    name: 'AuditCreate',
    component: AuditCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_TECHNICIAN']
    }
  },

  {
    path: '/audit/show/:auditId',
    name: 'AuditShow',
    component: AuditShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_STRUCTURE', 'ROLE_TECHNICIAN']
    }
  },

  {
    path: '/technicians',
    name: 'TechnicianIndex',
    component: TechnicianIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_STRUCTURE']
    }
  },

  {
    path: '/technician/show/:techId',
    name: 'TechnicianShow',
    component: TechnicianShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_STRUCTURE']
    }
  },

  {
    path: '/technician/edit/:techId',
    name: 'TechnicianEdit',
    component: TechnicianCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_STRUCTURE']
    }
  },
  {
    path: '/technician/create',
    name: 'TechnicianCreate',
    component: TechnicianCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_STRUCTURE']
    }
  },

  {
    path: '/structures',
    name: 'StructureIndex',
    component: StructureIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
    }
  },

  {
    path: '/structure/show/:structureId',
    name: 'StructureShow',
    component: StructureShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
    }
  },

  {
    path: '/structure/edit/:structureId',
    name: 'StructureEdit',
    component: StructureCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
    }
  },
  {
    path: '/structure/create',
    name: 'StructureCreate',
    component: StructureCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
    }
  },

  {
    path: '/admins',
    name: 'AdminIndex',
    component: AdminIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/admin/show/:adminId',
    name: 'AdminShow',
    component: AdminShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/admin/edit/:adminId',
    name: 'AdminEdit',
    component: AdminCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN']
    }
  },
  {
    path: '/admin/create',
    name: 'AdminCreate',
    component: AdminCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/practices',
    name: 'PracticeIndex',
    component: PracticeIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_STRUCTURE', 'ROLE_TECHNICIAN']
    }
  },
  {
    path: '/practice/edit/:practiceId',
    name: 'PracticeEdit',
    component: PracticeEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
    }
  },

  {
    path: '/resources',
    name: 'ResourceIndex',
    component: ResourceIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_STRUCTURE', 'ROLE_TECHNICIAN']
    }
  },

  {
    path: '/resource/show/:resourceId',
    name: 'ResourceShow',
    component: ResourceShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_STRUCTURE', 'ROLE_TECHNICIAN']
    }
  },

  {
    path: '/resource/edit/:resourceId',
    name: 'ResourceEdit',
    component: ResourceCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_STRUCTURE', 'ROLE_TECHNICIAN']
    }
  },
  {
    path: '/resource/create/',
    name: 'ResourceCreate',
    component: ResourceCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/videos',
    name: 'VideoIndex',
    component: VideoIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_STRUCTURE', 'ROLE_TECHNICIAN', 'ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/video/show/:videoId',
    name: 'VideoShow',
    component: VideoShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_STRUCTURE', 'ROLE_TECHNICIAN']
    }
  },

  {
    path: '/video/edit/:videoId',
    name: 'VideoEdit',
    component: VideoCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
    }
  },
  {
    path: '/video/create/',
    name: 'VideoCreate',
    component: VideoCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN']
    }
  },

  {
    path: '/feedbacks',
    name: 'FeedbackIndex',
    component: FeedbackIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
    }
  },
  {
    path: '/feedback/show/:feedbackId',
    name: 'FeedbackShow',
    component: FeedbackShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
    }
  }

]

const router = new VueRouter({
  routes
})

// the meta: {requiresAuth: true} key. If a route has the meta key, it checks the store for a token; if present, it redirects them to the login route.
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const checkRoles = to.matched.some(record => {
      return record.meta.roles && store.getters.roles.some(r => record.meta.roles.includes(r)) && store.getters.isAuthenticated
    })

    if (checkRoles) {
      next()
      return
    } else if (store.getters.isAuthenticated) {
      next('/')
      return
    } else {
      next('/login')
      return
    }

    // Gestion pages réservées aux utilisateurs connectés
    // eslint-disable-next-line no-unreachable
    if (store.getters.isAuthenticated) {
      next()
    }
    next('/login')
  } else {
    next()
  }
})

// The meta: {guest: true} stops users that are logged in from accessing the routes with the guest meta.
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.guest)) {
    if (store.getters.isAuthenticated) {
      next('/')
      return
    }
    next()
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js